import { BaseLoginError } from "./BaseLoginError";

export class UserLocked extends BaseLoginError {

    constructor(isShow: boolean) {
        super (isShow);
    }

}